import React, { useState, useEffect } from 'react';
import { Box, BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import {
  HomeRounded as HomeIcon,
  LibraryBooksRounded as MbeIcon,
  ImportContactsRounded as CaseIcon,
  ForumRounded as CommunityIcon,
  PersonRounded as ProfileIcon
} from '@mui/icons-material';

const MobileLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { darkMode } = useApp();
  const [value, setValue] = useState(0);

  // 현재 라우트에 따라 하단 탭 아이콘 활성화
  useEffect(() => {
    const path = location.pathname;
    if (path === '/') setValue(0);
    else if (path.startsWith('/mbe_test')) setValue(1);
    else if (path.startsWith('/community/casebrief')) setValue(2);
    else if (path.startsWith('/community/success-stories') || path.startsWith('/community/free-board')) setValue(3);
    else if (path.startsWith('/my-learning') || path.startsWith('/settings')) setValue(4);
    else setValue(0);
  }, [location]);

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh',
      bgcolor: darkMode ? '#0e0e0e' : '#fdfbf7', // 다크모드에서는 깊은 블랙, 라이트모드에서는 프리미엄 웜톤 베이지
      pb: 'env(safe-area-inset-bottom, 20px)', // 아이폰 하단 물리 바 safe-area 및 추가 기기 마진 대응
      boxSizing: 'border-box',
      transition: 'background-color 0.3s ease'
    }}>
      {/* 콘텐츠 영역 (하단 탭 바 높이 및 safe area 고려한 하단 패딩) */}
      <Box sx={{ flexGrow: 1, width: '100%', pb: '80px' }}>
        {children}
      </Box>

      {/* 플로팅 탭 바 (글래스모피즘 극대화) */}
      <Paper sx={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0, 
        zIndex: 9999,
        background: darkMode ? 'rgba(14, 14, 14, 0.75)' : 'rgba(253, 251, 247, 0.75)',
        backdropFilter: 'blur(25px)',
        WebkitBackdropFilter: 'blur(25px)',
        borderTop: darkMode ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid rgba(0, 0, 0, 0.05)',
        boxShadow: darkMode ? '0 -8px 32px rgba(0, 0, 0, 0.5)' : '0 -5px 25px rgba(0, 0, 0, 0.06)',
        pb: 'env(safe-area-inset-bottom, 12px)', // 세로 노치 영역 반응형 대응 패딩
        pt: 1,
        borderRadius: '16px 16px 0 0', // 상단 모서리 둥글게 처리하여 모던 네이티브 느낌 극대화
        transition: 'background 0.3s ease, border-color 0.3s ease'
      }} elevation={0}>
        <BottomNavigation
          showLabels
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
            if (newValue === 0) navigate('/');
            else if (newValue === 1) navigate('/mbe_test');
            else if (newValue === 2) navigate('/community/casebrief');
            else if (newValue === 3) navigate('/community/success-stories');
            else if (newValue === 4) navigate('/my-learning');
          }}
          sx={{ 
            height: 60,
            background: 'transparent',
            '@keyframes navBounce': {
              '0%': { transform: 'scale(1) translateY(0)' },
              '40%': { transform: 'scale(0.85) translateY(2px)' },
              '70%': { transform: 'scale(1.12) translateY(-6px)' },
              '100%': { transform: 'scale(1) translateY(-2px)' }
            },
            '& .MuiBottomNavigationAction-root': {
              minWidth: 'auto',
              color: darkMode ? 'rgba(255, 255, 255, 0.38)' : 'rgba(0, 0, 0, 0.35)',
              transition: 'color 0.2s ease, transform 0.2s ease',
              '&.Mui-selected': {
                color: darkMode ? '#e5e0d8' : '#1a1a1a', // 다크모드에서는 밝은 웜화이트, 라이트모드에서는 딥차콜
                animation: 'navBounce 0.45s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards',
                transform: 'translateY(-2px)'
              }
            },
            '& .MuiBottomNavigationAction-label': {
              fontSize: '0.62rem',
              fontWeight: 600,
              mt: 0.5,
              transition: 'font-size 0.2s ease, font-weight 0.2s ease',
              '&.Mui-selected': {
                fontSize: '0.68rem',
                fontWeight: 800,
              }
            }
          }}
        >
          <BottomNavigationAction label="홈" icon={<HomeIcon sx={{ fontSize: '1.4rem' }} />} />
          <BottomNavigationAction label="MBE" icon={<MbeIcon sx={{ fontSize: '1.4rem' }} />} />
          <BottomNavigationAction label="자료실" icon={<CaseIcon sx={{ fontSize: '1.4rem' }} />} />
          <BottomNavigationAction label="커뮤니티" icon={<CommunityIcon sx={{ fontSize: '1.4rem' }} />} />
          <BottomNavigationAction label="마이" icon={<ProfileIcon sx={{ fontSize: '1.4rem' }} />} />
        </BottomNavigation>
      </Paper>
    </Box>
  );
};

export default MobileLayout;
